import axios from "axios";
import { obterParametrosDaURL } from "../../functions";
import { ApiException } from "./api-exception";
import { configs } from "../../configs";

export const api = axios.create({
  baseURL: configs.BASE_URL_API_PROD,
  headers: {
    "X-Front-Version": "28/01/2026",
  },
});

export const apiRelatorios = axios.create({
  // baseURL: "https://liberacaodesenha.radinfo.com.br/relatoriosback/api",
  baseURL: "https://api.radinfo.com.br/relatorios_notify/api",
  // baseURL: "http://192.168.1.173:9000/api"
});

export const apiAssinaturaDigital = axios.create({
  baseURL: "https://api.radinfo.com.br/assinatura_digital/nosso_lar/api",
});

export const obterMensagemDaApi = (error: any)  => (error as ApiException).message;

export const obterStatusDaApi = (error: any)  => (error as ApiException).status;

api.interceptors.request.use(
  (config) => {

    const { token } = obterParametrosDaURL();

    if (token && config.headers)
      config.headers.Authorization = `Bearer ${token}`;

    return config;
  },
  (error) => Promise.reject(error)
);